import axios from "axios";

export const getVacantLockers = async (
  searchType,
  searchValue,
  page = 1,
  pageSize = 10
) => {


  let url = `/o/c/vacantlockers?page=${page}&pageSize=${pageSize}`;

  if (searchValue) {
    if (searchType === "branchName") {
      url += `&search=${encodeURIComponent(searchValue)}`;
    } else {
      const filter = `contains(${searchType},'${searchValue}')`;
      url += `&filter=${encodeURIComponent(filter)}`;
    }
  }

  const response = await fetch(url, {
    credentials: "include",
    headers: {
      "X-CSRF-Token": window.Liferay?.authToken,
      "Content-Type": "application/json",
      Accept: "application/json"
    },
  });

  if (!response.ok) {
    throw new Error(`API failed: ${response.status}`);
  }

  const data = await response.json();
  console.log("data--------------", data)
  return {
    items: data.items || [],
    total: data.totalCount || 0,
  };
};


